import React from 'react';
import {
    ImageList,
    ImageListItem,
    ImageListItemBar,
    IconButton,
    Typography,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import '../style/field-details.scss';

export const ImageRender = ({ data, deletedItems, setDeletedItems }) => {
    const removeImage = (imageId) => {
        setDeletedItems((deletedItems) => ({
            ...deletedItems,
            [imageId]: true,
        }));
    };

    if (!data) return <Typography h1>Loading</Typography>;
    return (
        <ImageList className="image-list" cols={1}>
            {data?.posters.map((images, index) => (
                <ImageListItem
                    className={`${
                        deletedItems[index]
                            ? 'delete-opacity'
                            : 'image-list-item'
                    }`}
                    key={`field-image-${index}`}
                >
                    <ImageListItemBar
                        sx={{
                            borderRadius: '10px',
                            background:
                                'linear-gradient(to bottom, rgba(0,0,0,0.7) 0%, ' +
                                'rgba(0,0,0,0.3) 70%, rgba(0,0,0,0) 100%)',
                        }}
                        position="top"
                        actionIcon={
                            <IconButton sx={{ color: 'white' }}>
                                {deletedItems[index] ? (
                                    <CancelIcon
                                        onClick={() => {
                                            const { [index]: _, ...tempObj } =
                                                deletedItems;
                                            setDeletedItems(tempObj);
                                        }}
                                    />
                                ) : (
                                    <DeleteIcon
                                        onClick={() => removeImage(index)}
                                    />
                                )}
                            </IconButton>
                        }
                        actionPosition="right"
                    />
                    <img className="img" src={images} />
                </ImageListItem>
            ))}
        </ImageList>
    );
};
